export const customerTypes = [
    {
        label: 'Carrier',
        value: 'Carrier',
    },
    {
        label: 'Shipper',
        value: 'Shipper',
    },
];
export const statusList = [
    { label: 'Confirmed', value: 'confirmed', localizationSlug: 'CONFIRMED' },
    { label: 'Awaiting', value: 'awaiting', localizationSlug: 'AWAITING' },
    { label: 'Expired', value: 'expired', localizationSlug: 'EXPIRED' },
    { label: 'Declined', value: 'declined', localizationSlug: 'DECLINED' },
];
export const orderTypes = [
    {
        label: 'Import',
        value: 'import',
    },
    {
        label: 'Export',
        value: 'export',
    },
    {
        label: 'Domestic',
        value: 'domestic',
    },
    {
        label: 'Reposition',
        value: 'reposition',
    },
];
export const hazardous = [
    {
        label: 'Yes',
        value: 'Yes',
    },
    {
        label: 'No',
        value: 'No',
    },
];
